import React from 'react';
import styled from 'styled-components';

import { Anchor, Image, Label, LabelProps, Logger } from 'UI-Dash-Commons-UI';

import SectionUtils from '../utils/SectionUtils';
import MenuSection from '../../../types/MenuSection';
const TAG = 'TopDropdownMenuSectionComponent';

type TopDropdownMenuSectionComponentProps =
    {
        sectionSpec: MenuSection,
        onSectionActivated: ( sectionSpec: MenuSection ) => void
    };

const TopDropdownMenuSectionComponent: React.StatelessComponent<TopDropdownMenuSectionComponentProps> = ( {
                                                                                                              sectionSpec,
                                                                                                              onSectionActivated
                                                                                                          } ) =>
{
    const sectionImage: string | undefined = SectionUtils.findImage( sectionSpec.id, true );

    const handleHeaderClick: ( event: React.MouseEvent<HTMLSpanElement> ) => void = ( event: React.MouseEvent<HTMLSpanElement> ) =>
    {
        event.preventDefault();

        Logger.debug( TAG, 'Top menu section clicked: \'' + sectionSpec.id + '\'' );

        if ( sectionSpec.sectionUrlType )
        {
            onSectionActivated( sectionSpec );
        }
    };

    // First add the title
    return <SectionComponent
        onClick={handleHeaderClick}
    >
        <SectionHeader>
            <SectionImage
                alt={sectionSpec.displayName}
                src={sectionImage}
            />
            <SectionText>
                <SectionTitle
                    text={sectionSpec.displayName}
                    href={sectionSpec.externalUrl ? sectionSpec.externalUrl : '#'}
                    onClick={() => ( false )}
                />
                <SectionSubtitle
                    text={sectionSpec.displaySubtitle}
                />
            </SectionText>
        </SectionHeader>
    </SectionComponent>;
};

const SectionComponent = styled.span`
  padding: 15px 5px 15px 7px;

  text-align: left;

  cursor:pointer;

  border-top: 1px solid #e9eaec; 

  :hover {
    background-color: #e9f6fd;
  }
  :first-child {
    border-top: none; 
  }

  :first-child {
    img {
       top: 8px;
    } 
  }

`;

const SectionHeader = styled.div`
  display: flex;
  position:relative;
  top: -3px;
  padding-right:15px
`;

const SectionText = styled.div`
    display:inline-block;
    vertical-align:middle;
    padding-left: 1px;
    padding-top: 9px;
`;

const SectionSubtitle = styled<LabelProps>( Label )`
    display: none;
    display:${props => props.text != null && 'block'};

    margin-top:4px;

    color: #97a1a8;
    font-family: ${props => props.theme.fonts.regular};
    font-size: 12px;  
`;

const SectionTitle = styled( Anchor )`
  font-size: 13px;
  color: #1e222b;  
  font-family: ${props => props.theme.fonts.regular};
  text-decoration: none;
`;

const SectionImage = styled( Image )`
  display: inline-block;  
  vertical-align: middle; 

  width: 30px;
  height: 30px;
  padding-right: 8px; 
  position:relative;
  top:1px;
`;

export default TopDropdownMenuSectionComponent;
